import {Controller} from '@stimulus/core'
import Quill from 'quill'
//import highlight 




export default class extends Controller {
  connect() {
    var toolbarOptions = [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],
    
      [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      ['link','video'], 
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    
      //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    
      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'align': [] }],
      ['clean']                                         // remove formatting button
    ];
   var quill = new Quill(this.element, {
      modules: {
        toolbar: toolbarOptions
      },
      theme: 'snow'
    });
    var elem = this.element;
    quill.on('text-change', function(delta, oldDelta, source) {
      document.getElementById(elem.dataset.target).value = quill.root.innerHTML;
  });
  }
}
